<template>
  <div>
    <div class="containerBackgroundTable bg-primary">
      <div class="ml-5 mr-5 pt-4 d-flex flex-column">
        <div class="d-flex align-content-start flex-wrap">
          <h2 class="ml-8 mr-2 mb-5 white--text">Cloud Storage</h2>
        </div>
        <div class="d-flex align-content-start flex-wrap">
          <div class="ml-4 mr-2" style="width: 100%;">
            <v-toolbar class="pl-0" flat color="transparent">
              <v-row justify="start">
                <v-col lg="6">
                  <v-text-field
                    v-model="search"
                    solo
                    prepend-inner-icon="mdi-magnify"
                    color="black"
                    label="Buscar"
                    class="searchWidth mt-4"
                  >
                    <v-icon dark>mdi-face-agent</v-icon>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-btn class="button-gray" @click="newBucket">Nuevo</v-btn>
            </v-toolbar>
          </div>
        </div>
      </div>
    </div>
    <div>
      <callStorage class="ml-5 mr-5 mt-6" :search="search" />
    </div>
  </div>
</template>

<script>
import callStorage from "../../components/storage-cloud/storageTable";

export default {
  data: () => ({
    search: "",
  }),
  components: {
    callStorage,
  },
  methods: {
    newBucket() {
      this.$router.push(`/storagecloud/newbucket`);
    },
  },
};
</script>
<style lang="scss">
@import "../../styles/global.scss";
</style>
